import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import Sortings from "../../Misc/Sortings";
import Filters from "../../Misc/Filters";
import Searchbox from "../../Misc/Searchbox";
import StaffDocumentListItem from "./StaffDocumentListItem";
import StaffDocumentEdit from "./StaffDocumentEdit";
import StaffDocumentItem from "./StaffDocumentItem";

export default class StaffDocuments extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editItem: false,
      search: [],
      customListKey: "",
      filters: {
        show: false,
        active: [],
        default: [
          {
            field: "client",
            compare: "EQL",
            value: props.client,
          },
        ],
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      sortings: {
        all: [
          {
            id: "byNameAsc",
            active: false,
            title: "По алфавиту",
            value: ["name ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }

  refreshList = async () => {
    this.setState({ customListKey: this.context.key() });
  };

  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };
  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  handleSearch = (text) => {
    let search = text
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${text}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({ search });
  };

  onEditStart = (item = {}) => {
    this.setState({ editItem: item });
  };

  onEditFinish = () => {
    this.setState({ editItem: false }, () => this.refreshList());
  };

  onEditClose = () => {
    this.setState({ editItem: false });
  };

  render() {
    const { documentId } = this.props;
    const { editItem } = this.state;

    if (documentId) {
      return (
        <>
          <div className="container">
            <StaffDocumentItem documentId={documentId} />
          </div>
        </>
      );
    }

    return (
      <>
        {editItem && (
          <StaffDocumentEdit
            item={editItem || {}}
            onClose={this.onEditClose}
            onFinish={this.onEditFinish}
            itemId={editItem ? editItem.id : null}
            client={this.props.client}
          />
        )}

        <div className="">
          <div className="">
            <div className="">
              <div className="w-100 mr-0 pb-5 d-block d-lg-flex align-items-center justify-content-between">
                <div className="text-nowrap d-inline-block mr-2">
                  <Searchbox onSearch={this.handleSearch} />
                </div>
                <div>
                  <button
                    onClick={() => this.onEditStart({})}
                    title="Добавить документ"
                    className={`btn  btn-icon btn-light mr-2`}
                  >
                    <i className="flaticon2-add-1 p-0 align-middle text-muted"></i>
                  </button>
                  <button
                    className="btn btn-light mr-2"
                    onClick={() => this.toggleFilters(!this.state.filters.show)}
                  >
                    <i
                      className={`fa fa-filter p-0 ${
                        this.state.filters.show ? "text-primary" : "text-muted"
                      }`}
                    ></i>
                  </button>
                  <Sortings
                    changeFn={this.handleSortings}
                    sortings={this.state.sortings.all}
                  />
                </div>
              </div>
            </div>
            <div
              className={`${
                this.state.filters.show ? "d-flex" : "d-none"
              }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
            >
              <Filters
                changeFn={this.handleFilters}
                filters={this.state.filters.all}
              />
            </div>
            <div className="card-body px-5">
              {this.props.client && (
                <List
                  keyField="id"
                  listKey="staffDocList"
                  path="/identity/list"
                  key={this.state.customListKey}
                  fulltext={JSON.stringify(this.state.search)}
                  search={JSON.stringify(
                    this.state.filters.active.concat(this.state.filters.default)
                  )}
                  sort={JSON.stringify(this.state.sortings.active)}
                  limit={20}
                  hideSinglePageNav
                >
                  <StaffDocumentListItem
                    onFinish={this.refreshList}
                    onEditClick={this.onEditStart}
                  />
                </List>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
